import script from "./popover-base.vue?vue&type=script&setup=true&lang=ts"
export * from "./popover-base.vue?vue&type=script&setup=true&lang=ts"

import "./popover-base.vue?vue&type=style&index=0&id=fb9c18ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb9c18ea"]])

export default __exports__